<template>
  <div class="user_page">
    <div class="d-flex align-center">
      <router-link to="/inventarization">
        <div class="back-btn mr-3">
          <v-icon class="pointer-events-none">mdi-arrow-left</v-icon>
        </div>
      </router-link>

      <h3 class="title-page">{{ $t("inventarization") }}</h3>
    </div>

    <span class="invTopDate"
      >{{
        responseData?.warehouseName
          ? responseData.warehouseName
          : $t("myOffice")
      }}
      - {{ responseData?.date }}</span
    >
    <div>
      <div class="admin_container" style="margin-top: 24px">
        <div class="mb-4 flex-justify-end">
          <v-btn
            v-if="currentInvStatus !== 'START'"
            @click="downloadExelFile"
            color="primary"
            :loading="excelExportLoading"
            >Скачать в Excel</v-btn
          >
        </div>
        <div class="division_main">
          <div
            class="text-right pb-3 ma-n2 d-flex flex-wrap justify-md-space-between"
          ></div>
          <TableWithFilter
            fixed-header
            hide-default-footer
            :headers="
              $route.query.type === 'forOffice'
                ? headerForOffice
                : headersSecond
            "
            :items="invData"
            :page="tableOptions.page"
            :options.sync="tableOptions"
            class="table-wth-children table_cover"
          >
            <template #filter.productName>
              <div class="pa-1">
                <custom-input-text
                  style="width: 70%"
                  class="user_input no-margin"
                  @input="debouncedSearchByName"
                  v-model="searchedName"
                  clearable
                />
              </div>
            </template>
            <template #filter.resPerson>
              <vue-select
                ref="ProductSelectRef"
                infinite
                :name="$t('measure')"
                @CHANGE_VALUE="setResperson"
                @changeText="debouncedUserSearchByName"
                @changeText2="setSearchValue"
                @input="clearSelectedUser"
                v-model="selectedUser"
                :items="usersList"
                clearable
                itemText="fullName"
                class="user_input no-margin"
              ></vue-select>
              <!--              <CustomSelect-->
              <!--                v-model="selectedUser"-->
              <!--                :items="usersList"-->
              <!--                @input="setResperson"-->
              <!--                item-text="fullName"-->
              <!--                :name="$t('measure')"-->
              <!--                class="col-sm-6 col-12 user_input no-margin"-->
              <!--                rules="required"-->
              <!--              ></CustomSelect>-->
            </template>
            <template #filter.dataChange>
              <date-picker
                v-model="value1"
                format="YYYY-MM-DD"
                @change="dataChanged"
                type="date"
                placeholder="Select date"
              ></date-picker>
            </template>
            <template #item.unit_type="{ item }">
              <span>{{ item[`unit_type_${$i18n.locale}`] }}</span>
            </template>
            <template #item.count="{ item }">
              <span>{{ Number(item.count) }}</span>
            </template>
            <template #item.rack="{ item }">
              <span>{{ item.address.stillageAddress }}</span>
            </template>
            <template #item.carriage="{ item }">
              <span>{{ item.address.carriageAddress }}</span>
            </template>
            <template #item.resPerson="{ item }">
              <span>{{ item.userName }}</span>
            </template>
            <template #item.dataChange="{ item }">
              <span>{{ item.date }}</span>
            </template>
            <template #item.productName="{ item }">
              <span>{{
                item.productName ? item[`productName_${$i18n.locale}`] : ""
              }}</span>
            </template>
            <template #item.status="{ item }">
              <div v-if="currentInvStatus === 'START'" class="actions">
                <v-btn
                  v-if="item.valid === 'INVALID'"
                  @click="editInvalidProduct(item)"
                  variant="outlined"
                  color="blue"
                >
                  <vue-icon icon="newPencilIcon"></vue-icon>
                </v-btn>
                <v-btn
                  v-if="item.valid !== 'INVALID'"
                  @click="validProduct(item.id)"
                  color="success"
                  variant="outlined"
                  :class="{ disableChecker: item.valid === 'VALID' }"
                >
                  <vue-icon icon="verifyIcon"></vue-icon>
                </v-btn>
                <v-btn
                  v-if="item.valid !== 'VALID'"
                  @click="invalidProduct(item)"
                  color="error"
                  variant="outlined"
                  :class="{ disableChecker: item.valid === 'INVALID' }"
                >
                  <vue-icon icon="warningIcon"></vue-icon>
                </v-btn>
                <v-btn
                  v-if="
                    item.valid !== null &&
                    item.valid === 'INVALID' &&
                    $route.query.type === 'notForOffice'
                  "
                  @click="$refs.inventaryDialogRef.open(item)"
                  color="warning"
                  variant="outlined"
                >
                  <vue-icon icon="newEyeIcon"></vue-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-icon v-if="item.valid !== 'INVALID'" color="success"
                  >mdi-check-decagram</v-icon
                >

                <v-icon
                  @click="historyInvalid(item)"
                  color="error"
                  v-if="item.valid !== 'VALID'"
                  >mdi-alert</v-icon
                >
              </div>
            </template>
          </TableWithFilter>
          <VuePagination
            @input="changePage"
            v-model="tableOptions.page"
            :length="lastPage"
          />
        </div>
      </div>
    </div>
    <InventarizationItemDialog
      ref="inventarizationItemDialogRef"
      @clearAndAddTable="clearAndAddTable"
    ></InventarizationItemDialog>
    <InventoryRefDialog
      @tableUpdate="getInventarizationData"
      :warehouse="invontaryId"
      :inventory="stillageId"
      ref="inventaryDialogRef"
    ></InventoryRefDialog>
    <v-dialog style="background: #fff" v-model="invalidModal" max-width="400px">
      <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
        <v-form @submit.prevent="handleSubmit(save)">
          <v-card>
            <div>
              <v-card-title> {{ $t("productReport") }}</v-card-title>
            </div>
            <div class="container-radios">
              <div class="radio-div">
                <ValidationProvider rules="required">
                  <label>
                    <input
                      type="radio"
                      value="ITEM_IS_NOT_IN_PLACE"
                      v-model="invalidCause.type"
                    />
                    {{ $t("productIsNotPlace") }}
                  </label>
                </ValidationProvider>
              </div>
              <div class="radio-div">
                <ValidationProvider rules="required">
                  <label>
                    <input
                      type="radio"
                      v-model="invalidCause.type"
                      value="QUANTITY_IS_MISSING"
                    />
                    {{ $t("numNotEnough") }}
                  </label>
                </ValidationProvider>
              </div>
              <div class="radio-div">
                <ValidationProvider rules="required">
                  <label>
                    <input
                      type="radio"
                      v-model="invalidCause.type"
                      value="QUANTITY_IN_EXCESS"
                    />
                    {{ $t("quantityInExcess") }}
                  </label>
                </ValidationProvider>
              </div>
              <div>
                <ValidationProvider
                  :name="$t('quantity')"
                  :rules="`required|min_value:1|max_value:${invalidMaxCount}`"
                  v-slot="{ errors }"
                >
                  <custom-input-text
                    class="user_input no-margin"
                    v-model="invalidCause.count"
                    type="number"
                    min="1"
                  />
                  <span class="errormessage">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="container-are">
              <CustomTextTextarea
                v-model="invalidCause.comment"
                :label="$t('comment')"
                class="user_input"
              ></CustomTextTextarea>
              <v-btn type="submit" block color="primary">{{ $t("add") }}</v-btn>
            </div>
          </v-card>
        </v-form>
      </validation-observer>
    </v-dialog>
    <v-dialog
      style="background: #fff"
      v-model="invalidHistoryModal"
      max-width="400px"
    >
      <v-card>
        <div>
          <v-card-title>{{ $t("productReport") }}</v-card-title>
          <div class="container-radios">
            <div class="history-container">
              <div class="history-otchet">
                <v-icon color="error">mdi-alert</v-icon>
                <span>
                  {{ invalidCauseHistory.productName }} <br />
                  {{ $t(invalidStatus[invalidCauseHistory.type]) }}:
                  {{ invalidCauseHistory.count }}
                </span>
              </div>
              <span class="commentary">
                <span class="label">{{ $t("comment") }}</span>
                <span class="value">{{ invalidCauseHistory.comment }}</span>
              </span>
            </div>
          </div>
          <div
            style="margin: 10px 5px; display: flex; justify-content: flex-end"
          >
            <v-btn color="primary" @click="closeHistoryModal">{{
              $t("close")
            }}</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import BackBtn from "@/components/ui/BackBtn";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import InventarizationItemDialog from "@/components/omtk/InventarizationItemDialog";
import InventoryRefDialog from "@/components/inventory/InventoryRefDialog";
// import { trueSet } from "@/utils/pureFunctions.js";
import { debounce, makerPagination } from "../../../utils/pureFunctions";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueSelect from "../../../components/ui/vue-select/VueSelect.vue";
import VuePagination from "@/components/ui/vue-pagination/VuePagination.vue";

export default {
  name: "inventarization-item",
  props: ["id"],
  data() {
    return {
      lastPage: 0,
      responseData: null,
      invalidStatus: {
        QUANTITY_IS_MISSING: "numNotEnough",
        ITEM_IS_NOT_IN_PLACE: "productIsNotPlace",
        QUANTITY_IN_EXCESS: "quantityInExcess",
      },
      invalidCause: {
        type: "",
        count: 1,
        comment: "",
      },
      invalidCauseHistory: {
        type: "",
        count: 1,
        comment: "",
        productName: "",
      },
      tableOptions: {
        page: 1,
        limit: 8,
      },
      invalidModal: false,
      excelExportLoading: false,
      invalidProductId: null,
      invalidHistoryModal: false,
      invalidMaxCount: null,
      currentInvStatus: "",
      stillageId: null,
      invontaryId: null,
      value1: null,
      formattedDate: null,
      userSearchText: null,
      usersList: [],
      selectedUser: null,
      picker: null,
      items: [],
      qrDetails: {},
      contracts: [],
      products: [],
      productItemId: null,
      warehouseData: {},
      type: false,
      invData: [],
      inventarizationId: null,
      searchedName: null,
    };
  },

  methods: {
    async save() {
      this.showLoading();
      try {
        await this.$http.post(
          `inventarization-log/invalid/${this.invalidProductId}`,
          this.invalidCause
        );
        this.$refs.validationObserver.reset();
        this.invalidModal = false;
        this.getInventarizationData();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    setSearchValue(value) {
      this.userSearchText = value;
    },
    async changePage() {
      await this.getInventarizationData();
    },
    async userSelectSearch() {
      const value = this.userSearchText?.trim();
      if (value === "") {
        this.userSearchText = null;
      } else {
        this.userSearchText = value;
      }
      await this.getUserList();
    },
    async clearSelectedUser(value) {
      if (!value) {
        this.selectedUser = null;
        await this.getByWarehouse();
      }
    },
    async setResperson() {
      await this.getByWarehouse();
    },
    async dataChanged(value) {
      if (value == null) {
        this.formattedDate = null;
        return;
      }
      const date = new Date(value);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      const formattedDate = `${year}-${month}-${day}`;
      this.formattedDate = formattedDate;
      await this.getByWarehouse();
    },
    setProduct(products) {
      this.products = products;
    },
    async searchByName() {
      const value = this.searchedName?.trim();
      if (value === "") {
        this.searchedName = "";
      } else {
        this.searchedName = value;
      }

      await this.getInventarizationData();
    },
    clearAndAddTable(type, writeOffCount) {
      this.productItemId = null;
      this.$refs.formObs.reset();
      this.type = type;

      this.items.push({
        ...this.qrDetails,
        parentClassName: type ? "receive" : "reject",
        type,
        writeOffCount,
      });
    },
    downloadBlobFile: (file, fileName) => {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style.display = "none";
      const url = window.URL.createObjectURL(file);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      setTimeout(() => a.remove());
    },
    async downloadExelFile() {
      try {
        this.excelExportLoading = true;
        const { data } = await this.$http.get(
          `inventarization-log/export-excel`,
          {
            responseType: "blob",
            params: {
              inventarizationId: this.$route.params.id,
              forOffice: this.$route.query.type === "forOffice",
            },
          }
        );

        const name = this.responseData?.warehouseName
          ? this.responseData?.warehouseName
          : this.$t("myOffice");
        const date = this.responseData.date;

        this.downloadBlobFile(data, `${name}-${date}.xlsx`);
      } catch (e) {
        console.log(e);
      } finally {
        this.excelExportLoading = false;
      }
    },
    async getQrCodeDetails() {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get(
          `product-item/qr-code/detail/${this.productItemId}`
        );
        if (
          this.type &&
          this.items.length > 0 &&
          this.items.find((item) => item.id === this.productItemId)
        ) {
          const {
            /**
             * @type {Object}
             * @property {function} setErrors
             */
            formObs,
          } = this.$refs;
          formObs.setErrors({ id: this.$t("existingInv") });
          return;
        } else {
          this.qrDetails = { ...data };
          this.openInventarizationDialog(data, this.inventarizationId);
        }
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    openInventarizationDialog(data, inventarizationId) {
      const { inventarizationItemDialogRef } = this.$refs;
      if (inventarizationItemDialogRef) {
        inventarizationItemDialogRef.open(data, inventarizationId);
      }
    },
    // async startInventarization() {
    //   if (this.id !== "my-office") {
    //     this.showLoading();
    //     try {
    //       const {
    //         data: { data },
    //       } = await this.$http.post(
    //         `inventarization/start?warehouseid=${this.id}`
    //       );
    //       this.warehouseData = data;
    //       this.inventarizationId = data.id;
    //     } catch (e) {
    //       this.setResponseError({ error: e });
    //     } finally {
    //       this.clearLoading();
    //     }
    //   } else {
    //     this.showLoading();
    //     try {
    //       const {
    //         data: { data },
    //       } = await this.$http.post("inventarization/start-office");
    //       this.inventarizationId = data;
    //     } catch (e) {
    //       this.setResponseError({ error: e });
    //     } finally {
    //       this.clearLoading();
    //     }
    //   }
    // },
    async getUserList() {
      try {
        const {
          data: { data },
        } = await this.$http.get(`user/list`, {
          params: {
            page: 0,
            limit: 0,
            name: this.userSearchText,
          },
        });
        this.usersList = data;
      } catch (e) {
        console.log(e);
      }
    },
    // async getByWarehouse() {
    //   console.log(this.id);
    //   this.showLoading();
    //   try {
    //     const {
    //       data: { data },
    //     } = await this.$http.get(`inventarization/report-by-warehouse`, {
    //       params: {
    //         warehouseId: this.id,
    //         date: this.formattedDate,
    //         name: this.searchedName,
    //         placedUserId: this.selectedUser,
    //       },
    //     });
    //
    //     const parsedData = data.map((item) => {
    //       if (item.address && item.unit_type) {
    //         try {
    //           const addressParsed = JSON.parse(item.address);
    //           const unitTypeParsed = JSON.parse(item.unit_type);
    //
    //           return {
    //             ...item,
    //             address: addressParsed,
    //             unit_type: unitTypeParsed,
    //           };
    //         } catch (error) {
    //           console.error("ERROR parsing JSON: ", error);
    //
    //           return item;
    //         }
    //       } else {
    //         return item;
    //       }
    //     });
    //     this.invData = [...parsedData];
    //     this.inventarizationId = data.id;
    //   } catch (e) {
    //     this.setResponseError({ error: e });
    //   } finally {
    //     this.clearLoading();
    //   }
    // },
    closeHistoryModal() {
      this.invalidCauseHistory = {
        type: "",
        count: 1,
        comment: "",
        productName: "",
      };
      this.invalidProductId = null;
      this.invalidMaxCount = null;
      this.invalidHistoryModal = false;
    },
    async getInventarizationData() {
      this.showLoading();
      const params = {
        ...this.tableOptions,
      };
      const limit = this.tableOptions.limit;
      try {
        const {
          data: { data },
        } = await this.$http.get("inventarization-log/list", {
          params: {
            page: params.page - 1,
            limit: params.limit,
            inventarizationId: this.$route.params.id,
            forOffice: this.$route.query.type === "forOffice",
            productName: this.searchedName,
          },
        });
        this.stillageId = data.warehouseId;
        this.invontaryId = data.inventarizationId;
        const total = data.total;

        this.responseData = data;
        this.lastPage = makerPagination({ total, limit }).lastPage;
        const parsedData = data.items.map((item) => {
          if (item.address) {
            try {
              const addressParsed = JSON.parse(item.address);

              return {
                ...item,
                address: addressParsed,
              };
            } catch (error) {
              console.error("ERROR parsing JSON: ", error);

              return item;
            }
          } else {
            return item;
          }
        });
        this.invData = [...parsedData];
        this.currentInvStatus = data.inventarization;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async validProduct(productId) {
      try {
        await this.$http.post(`inventarization-log/valid/${productId}`);
        await this.getInventarizationData();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async invalidProduct(item) {
      this.invalidProductId = item.id;
      this.invalidMaxCount = Number(item.count);
      this.invalidModal = true;
    },

    async openInvalidProductHistory(item) {
      this.invalidProductId = item.id;
      this.invalidMaxCount = Number(item.count);
      this.invalidHistoryModal = true;
    },

    async historyInvalid(item) {
      try {
        const {
          data: { data },
        } = await this.$http.get(`inventarization-log/history/${item.id}`);
        this.invalidCauseHistory = {
          type: data.type,
          comment: data.comment,
          count: data.count,
          productName: item.productName,
        };
        this.openInvalidProductHistory(item);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },

    async editInvalidProduct(item) {
      try {
        const {
          data: { data },
        } = await this.$http.get(`inventarization-log/history/${item.id}`);
        console.log(data);
        this.invalidCause = {
          type: data.type,
          comment: data.comment,
          count: data.count,
        };
        this.invalidProduct(item);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  async created() {
    await this.getInventarizationData();
    // await this.getByWarehouse();
    await this.getUserList();
  },
  computed: {
    debouncedUserSearchByName() {
      return debounce(this.userSelectSearch, 300);
    },
    debouncedSearchByName() {
      return debounce(this.searchByName, 300);
    },
    headersSecond() {
      return [
        { text: this.$t("productName"), value: "productName" },
        { text: this.$t("measureShort"), value: "unit_type" },
        { text: this.$t("quantity"), value: "count" },
        { text: this.$t("warehouse"), value: "warehouseName" },
        { text: this.$t("warehouseFieldType.stillage"), value: "rack" },
        { text: this.$t("warehouseFieldType.carriage"), value: "carriage" },
        { text: this.$t("resPerson1"), value: "resPerson" },
        { text: this.$t("updatedDate"), value: "dataChange" },
        { text: this.$t("status"), value: "status" },
      ];
    },
    headerForOffice() {
      return [
        { text: this.$t("productName"), value: "productName" },
        { text: this.$t("quantity"), value: "count" },
        {
          text: this.$t("department2"),
          value: `departmentName_${this.$i18n.locale}`,
        },
        { text: this.$t("resPerson1"), value: "userName" },
        { text: this.$t("invCode"), value: "invCode" },
        { text: this.$t("updatedDate"), value: "date" },
        { text: this.$t("status"), value: "status" },
      ];
    },
    headers() {
      return [
        { text: this.$t("product"), value: "productName" },
        { text: this.$t("typeProduct"), value: "productTypeName" },
        { text: this.$t("count"), value: "count" },
      ];
    },
  },
  components: {
    VuePagination,
    VueSelect,
    TableWithFilter,
    InventoryRefDialog,
    // BackBtn,
    InventarizationItemDialog,
    DatePicker,
  },
};
</script>
<style scoped lang="scss">
.table_with_filter
  .table-wth-children-row.table-wth-children-row-parent.reject {
  background: #f08c77 !important;
}

.actions {
  display: flex;
  gap: 10px;
}

.disableChecker {
  opacity: 0.4;
  pointer-events: none;
  user-select: none;
}

.container-radios {
  padding: 10px 20px 20px 20px;
  border-bottom: 1px solid #dfe2e9;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.container-are {
  padding: 20px;
}

.history-otchet {
  display: flex;
  align-items: start;
  gap: 8px;

  span {
    font-family: "Rubik", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.59px;
    color: #48545d;
  }
}

.history-container {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .commentary {
    display: flex;
    flex-direction: column;
    margin-left: 33px;

    .label {
      font-family: "Rubik", sans-serif;
      font-size: 12px;
      font-weight: 400;
      line-height: 14.22px;
      color: #7a889b;
    }

    .value {
      font-family: "Rubik", sans-serif;
      font-size: 14px;
      font-weight: 500;
      line-height: 16.59px;
      color: #48545d;
    }
  }
}

.flex-justify-end {
  display: flex;
  justify-content: flex-end;
}

.invTopDate {
  font-family: "Rubik", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.33px;
  color: #303d4d;
}
</style>
